export const getNextIndex = (currentIndex: number, totalItems: number): number => {
  if (totalItems === 0) {
    return -1;
  }
  return currentIndex + 1 >= totalItems ? 0 : currentIndex + 1;
};

export const getPreviousIndex = (currentIndex: number, totalItems: number): number => {
  if (totalItems === 0) {
    return -1;
  }
  return currentIndex - 1 < 0 ? totalItems - 1 : currentIndex - 1;
};
